module.exports = __webpack_public_path__ + "static/media/dropdown_icon.5d8b4594.svg";